import {Component} from '@angular/core';

@Component({
    selector: 'app-accessibility',
    templateUrl: './accessibility.component.html',
    styleUrls: ['./accessibility.component.scss'],
    standalone: false
})
export class AccessibilityComponent {
    eclectusUrl = 'https://chercheurs.campusfrance.org/';
    mailContact = 'contact-accessibilite@campusfrance.org';
    defenderContactLink = 'https://www.defenseurdesdroits.fr/nous-contacter-355';
    defenderMapLink = 'https://www.defenseurdesdroits.fr/carte-des-delegues';

    constructor() { }
}
